import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getLoggedUserDetails } from "../../Actions/UserAction";
import { useNavigate } from 'react-router-dom';
import { LocalStorageKeys } from "../QuoteRequest/Content";
import { isJsonString } from "../../Helper/Helper";

const ViewRequestLink = () => {

    const dispatch = useDispatch();
    const search = window.location.search;   
    const params = new URLSearchParams(search);
    const quoteId = params.get('QuoteId');
    const userEmail = params.get('UserEmail');
    const navigate = useNavigate();

    useEffect(() => {
        if (userEmail) {
            dispatch(getLoggedUserDetails(userEmail))
                .then(userData => {
                    console.log('dd', userData);

                    if (!sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)
                        && (sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER) == null || sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER) == 'null')
                        || (isJsonString(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)) && JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))?.user?.id != userData?.user?.id)) {

                        const jsonUserData = JSON.stringify(userData);
                        sessionStorage.setItem(LocalStorageKeys.LOGGEDUSER, jsonUserData);
                    }

                    navigate("/viewquote", {
                        state: {
                            quoteId: quoteId,
                        },
                    });
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }, []);
    
}

export default ViewRequestLink;